import { render, staticRenderFns } from "./upload_page.vue?vue&type=template&id=02cf1881&scoped=true&"
import script from "./upload_page.vue?vue&type=script&lang=js&"
export * from "./upload_page.vue?vue&type=script&lang=js&"
import style0 from "./upload_page.vue?vue&type=style&index=0&id=02cf1881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cf1881",
  null
  
)

export default component.exports